import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Test = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      {/* Hero Section */}
      <section className="relative py-8 bg-[#EFEAE7]">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          <div className="text-center animate-fadeIn">
            <h1 className="mb-4 sm:mb-6">
              <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">WHAT'S</span>
              <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">ON</span>
            </h1>
            <p className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-4 max-w-2xl mx-auto px-4 sm:px-0">
              Stay updated with our latest events, special offers, and seasonal celebrations at Lotus Story
            </p>
          </div>
        </div>
      </section>

      {/* New Dish — Hoi An Heritage Chicken Rice */}
      <section className="py-12 bg-[#2E492A]">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Poster */}
            <div className="animate-slideIn lg:order-1">
              <img
                src="/hoianchickenrice.jpg"
                alt="Hoi An Heritage Chicken Rice — Com ga Hoi An"
                className="w-full rounded-lg shadow-lg hover-scale"
              />
            </div>

            {/* Details */}
            <div className="animate-slideIn lg:order-2">
              <div className="mb-4">
                <span className="inline-block bg-white/15 text-white px-4 py-2 rounded-full text-sm font-['Outfit'] font-medium">
                  NEW AT LOTUS STORY 🌿
                </span>
              </div>
              <h2 className="font-['Playfair_Display_SC'] text-3xl md:text-4xl font-bold text-[#EFEAE7] mb-2">
                Hoi An Heritage Chicken Rice
              </h2>
              <p className="font-['Outfit'] italic text-lg text-white/70 mb-6">
                Com ga Hoi An &nbsp;·&nbsp; Story of Central Vietnam
              </p>
              <div className="space-y-4 font-['Outfit'] text-white/90 mb-8">
                <p className="text-lg">
                  A beloved taste of Hoi An, bringing together tender poached chicken, golden turmeric rice, fresh herbs, pickled vegetables, house-made sauces and fragrant chicken broth.
                </p>
                <p className="text-lg">
                  Inspired by the rich culinary heritage of Central Vietnam, this timeless classic is now part of the Lotus Story experience.
                </p>
                <p className="text-lg italic text-[#EFEAE7]">
                  Come and taste a new story from Hoi An.
                </p>
              </div>
              <Link
                to="/reservation"
                className="inline-block px-8 sm:px-12 py-3 border border-white text-white rounded-sm font-['Outfit'] hover:bg-white hover:text-[#2E492A] transition-colors button-hover"
              >
                Book a Table
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Father's Day 2026 */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Details */}
            <div className="animate-slideIn">
              <div className="mb-4">
                <span className="inline-block bg-[#4F6632] text-white px-4 py-2 rounded-full text-sm font-['Outfit'] font-medium">
                  FATHER'S DAY 2026
                </span>
              </div>
              <h2 className="font-['Playfair_Display_SC'] text-3xl md:text-4xl font-bold text-[#2E492A] mb-3">
                Celebrate Dad at Lotus Story
              </h2>
              <p className="font-['Outfit'] italic text-lg text-[#4F6632] mb-6">
                Give Dad a Day to Remember
              </p>
              <div className="space-y-4 font-['Outfit'] text-gray-700 mb-8">
                <p className="text-lg">
                  Treat the father figure in your life to a Father's Day feast of Vietnamese flavours, shared the way they are meant to be — around one table, with everyone together.
                </p>
                <div className="space-y-2 border-l-2 border-[#4F6632]/30 pl-4">
                  <p className="font-medium text-[#2E492A]">Sunday, 6 September 2026</p>
                  <p>Lunch &nbsp;|&nbsp; 10:30 AM – 2:30 PM</p>
                  <p>Dinner &nbsp;|&nbsp; 5:00 PM – 9:00 PM</p>
                </div>
              </div>
              <Link
                to="/reservation"
                className="inline-block px-8 sm:px-12 py-3 border border-[#2E492A] bg-[#2E492A] text-white rounded-sm font-['Outfit'] hover:bg-transparent hover:text-[#2E492A] transition-colors button-hover"
              >
                Book Your Family Table
              </Link>
            </div>

            {/* Poster */}
            <div className="animate-slideIn">
              <img
                src="/fathersday2026.jpg"
                alt="Celebrate Dad at Lotus Story — Father's Day, Sunday 6 September 2026"
                className="w-full rounded-lg shadow-lg hover-scale"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Lunch / All Day Takeaway */}
      <section className="py-8 bg-[#EFEAE7]">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Details */}
            <div className="animate-slideIn">
              <div className="mb-4">
                <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-['Outfit'] font-medium">
                  LUNCH / ALL DAY TAKEAWAY
                </span>
              </div>
              <h2 className="font-['Playfair_Display_SC'] text-3xl md:text-4xl font-bold text-[#2E492A] mb-6">
                Lunch / All Day Takeaway
              </h2>
              <div className="space-y-4 font-['Outfit'] text-gray-700 mb-8">
                <p className="text-lg">
                  Discover a lunch experience that celebrates the vibrancy of Vietnamese cuisine reimagined through a contemporary Australian lens. Each dish, from beloved classics to modern creations, is prepared with the finest ingredients and a dedication to authentic, balanced flavour. Enjoy in-house or take away — a new favourite is ready to be found.
                </p>
              </div>
            </div>

            {/* Lunch Image */}
            <div className="animate-slideIn">
              <img
                src="/lunch2026.jpg"
                alt="Lunch / All Day Takeaway Menu"
                className="w-full rounded-lg shadow-lg hover-scale"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Event Gallery */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          <div className="text-center mb-12">
            <h3 className="font-['Playfair_Display_SC'] text-3xl font-bold text-[#2E492A] mb-4">
              Event Highlights
            </h3>
            <p className="font-['Outfit'] text-gray-600 max-w-2xl mx-auto">
              Take a glimpse of the authentic Vietnamese experience waiting for you and your father
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <div key={num} className="animate-fadeIn image-hover">
                <img 
                  src={`/newimages/newfood${num === 1 ? '' : num}.jpg`}
                  alt={`Vietnamese cuisine ${num}`}
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="bg-[#EFEAE7] py-8">
        <div className="w-1/2 md:w-1/3 lg:w-1/4 mx-auto h-px bg-[#4F6632] opacity-50"></div>
      </div>

      {/* Upcoming Events Teaser */}
      <section className="py-16 bg-[#EFEAE7]">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl text-center">
          <h3 className="mb-4 sm:mb-6">
            <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">UPCOMING</span>
            <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">EVENTS</span>
          </h3>
          <p className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-8 sm:mb-12 max-w-2xl mx-auto px-4 sm:px-0">
            Stay tuned for more exciting events and seasonal celebrations throughout the year
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center group">
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group-hover:border-[#4F6632]/20">
                <div className="w-16 h-16 bg-[#4F6632]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🎋</span>
                </div>
                <h4 className="font-['Playfair_Display_SC'] text-xl font-bold mb-2 text-[#4F6632]">Mid-Autumn Festival</h4>
                <p className="font-['Outfit'] text-sm text-gray-600">Traditional mooncake celebration with family gatherings</p>
              </div>
            </div>
            
            <div className="text-center group">
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group-hover:border-[#4F6632]/20">
                <div className="w-16 h-16 bg-[#4F6632]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🍜</span>
                </div>
                <h4 className="font-['Playfair_Display_SC'] text-xl font-bold mb-2 text-[#4F6632]">Pho Master Class</h4>
                <p className="font-['Outfit'] text-sm text-gray-600">Learn the art of authentic Vietnamese pho making</p>
              </div>
            </div>
            
            <div className="text-center group">
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group-hover:border-[#4F6632]/20">
                <div className="w-16 h-16 bg-[#4F6632]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🎆</span>
                </div>
                <h4 className="font-['Playfair_Display_SC'] text-xl font-bold mb-2 text-[#4F6632]">Tet Celebration</h4>
                <p className="font-['Outfit'] text-sm text-gray-600">Vietnamese New Year feast and cultural festivities</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Test;